import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '@widgets/header/Header';
import SearchHeader from '@widgets/search-header/SearchHeader';
import { AddProjectPopupProps } from '@features/project/project-creation/AddProjectPopup';
import Projects from '@features/projects/Projects';
import ProjectActionsPopup from '@features/projects/ProjectActionsPopup/ProjectActionsPopup';
import { useTheme } from '@context/themeContext';
import { SearchIcon } from '@icons/icons/SearchIcon';
import { ProjectActionsPopupType } from '@utils/types';
import Button from '@components/buttons/Button';
import { PlusIcon } from '@icons/icons/PlusIcon';
import { themeColors } from '@styles/theme';

type Props = {
    projectClickHandler: (projectId: string) => void;
} & Pick<AddProjectPopupProps, 'onProjectCreation'>;

const ProjectsLayout = ({ projectClickHandler, onProjectCreation }: Props) => {
    const [search, setSearch] = useState<string>('');
    const { theme } = useTheme();
    const { t } = useTranslation();

    const [popupType, setPopupType] = useState<ProjectActionsPopupType | null>(null);
    const [projectToDeleteId, setProjectToDeleteId] = useState<string>('');

    const onDeleteProject = useCallback(
        (id: string) => {
            setPopupType('delete');
            setProjectToDeleteId(id);
        },
        [setPopupType, setProjectToDeleteId]
    );

    return (
        <>
            <Header />
            <SearchHeader
                leftFields={
                    <div className={`search-block ${theme}`}>
                        <SearchIcon />
                        <input
                            type="text"
                            placeholder={t('header.projects-search')}
                            autoFocus
                            onChange={event => setSearch(event.target.value)}
                        />
                    </div>
                }
                rightFields={
                    <Button
                        onClick={() => setPopupType('model')}
                        img={
                            <PlusIcon
                                color={
                                    theme === 'light' ? themeColors.bluePurple : themeColors.white
                                }
                            />
                        }
                        text={t('header.project-add')}
                        colorType="transparent"
                    />
                }
            />
            <Projects
                search={search}
                projectClickHandler={projectClickHandler}
                onProjectDeleteFn={onDeleteProject}
            />
            <ProjectActionsPopup
                projectToDeleteId={projectToDeleteId}
                type={popupType}
                setPopupType={setPopupType}
                onProjectCreation={onProjectCreation}
            />
        </>
    );
};

export default ProjectsLayout;
